(function ($, Drupal) {

  'use strict';
  // Campus Codes
  const campusCodes = {
    '1': 'COAUR-1',
    '2': 'TXDAL-2',
    '3': 'CAGGV-3',
    '4': 'TXGRP-4',
    '5': 'MOMKC-5',
    '6': 'TNMEM-6',
    '7': 'CANHY-7',
    '8': 'ORPDX-8',
    '9': 'TXSAN-9',
    '10': 'CASBN-10',
    '11': 'CASAN-11',
    '12': 'MSHVN-12',
    '13': 'FLJAX-13',
    '14': 'FLMIR-14',
    '15': 'FLORL-15',
    '16': 'FLTPA-16',
    '17': 'ONLIN-17'
  };

  // PII Fields to exclude from GA
  const piiFields = ['firstname', 'lastname', 'email', 'dayphone', 'edit-firstname', 'edit-lastname', 'edit-email', 'edit-dayphone', 'name', 'your_title', 'your_phone', 'your_phone_number', 'ext', 'your_company', 'department', 'address', 'city', 'state'];

  // Form Names
  function getFriendlyFormName(formId) {
    if (formId.startsWith('webform-submission-hybrid-events')) {
      return 'Hybrid Events Form';
    } else if (formId.startsWith('webform-submission-enterprise-form-node')) {
      return 'Enterprise Form';
    } else if (formId.startsWith('webform-submission-enterprise-form-multi-steps-v3')) {
      return 'Enterprise Form - Multistep';}
      else if (formId.startsWith('webform-submission-enterprise-form-multi-steps')) {
      return 'Apply Form';
    } else if (formId.startsWith('webform-submission-schedule-tour')) {
      return 'Schedule Tour Form';
    } else if (formId.startsWith('webform-submission-virtual-info-session')) {
      return 'Virtual Info Session Form';
    }  else if (formId.startsWith('webform-submission-partners-day-event')) {
      return 'Event Form';
    } else if (formId.startsWith('webform-submission-open-house-form')) {
      return 'Open House Form';
    } else if (formId.startsWith('webform-submission-personality-assessment-7')) {
      return 'Personality Assessment Form';
    } else {
      if(formId.startsWith('webform-submission-enterprise-form')) {
        return 'Enterprise Form';
      } else {
        return formId;
      }
    }
  }

  function getCampusCode(rawCampus) {
    return campusCodes[rawCampus] || rawCampus || '';
  }

  function getFormSelection(form) {
    const program = form.find('.concorde_webform_campus_area_program_program, [name$="[program]"], [name="program"]').first().val() || '';
    const rawCampus = form.find('.concorde_webform_campus_area_program_campus, [name$="[LocationID]"], [name="LocationID"], [name$="[campus]"], [name="campus"]').first().val() || '';
    const eventChoice = form.find('[name="event_choice"]:checked').val() || '';
    const campus = eventChoice === 'virtual' ? '' : getCampusCode(rawCampus);

    return {
      programCode: program,
      campusCode: campus,
      leadItemId: program || campus || '1',
      eventChoice: eventChoice
    };
  }

  function hasLeadContextFields(form) {
    return form.find('.concorde_webform_campus_area_program_program, .concorde_webform_campus_area_program_campus, [name$="[program]"], [name="program"], [name$="[LocationID]"], [name="LocationID"]').length > 0;
  }

  function pushFormContext(form, formName) {
    if (!hasLeadContextFields(form)) {
      return;
    }

    const selection = getFormSelection(form);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'concorde_form_context',
      formName: formName,
      campusCode: selection.campusCode,
      programCode: selection.programCode,
      leadItemId: selection.leadItemId,
      ...(form.hasClass('hybrid-registration') ? { eventChoice: selection.eventChoice } : {})
    });
  }

  // The response carries the saved submission's values, so autofill and other
  // forms on the page cannot contaminate the conversion with sessionStorage.
  const completedHybridSubmissions = new Set();
  $.fn.concordeHybridCompleteSubmission = function(data) {
    if (!data || !data.submissionId || completedHybridSubmissions.has(data.submissionId)) return;
    completedHybridSubmissions.add(data.submissionId);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...data, campus: getCampusCode(data.campus) });
  };

  Drupal.behaviors.ajaxCompleteSubmission = {
    attach: function(context, settings) {
      $.fn.concordeAjaxCompleteSubmission = function(data) {
        var formName = sessionStorage.getItem('concorde_form_current');
        var program = sessionStorage.getItem('concorde_form_program');
        var campus = sessionStorage.getItem('concorde_form_campus');
        var zip = sessionStorage.getItem('concorde_form_zip');
        window.dataLayer.push({
          'event': 'ce_formSubmit',
          'formName': formName,
          'program': program,
          'campus': campus,
          'zip': zip
        });
        console.log('EVENT: ajax ce_formSubmit');
        // console.log('formName: ' + formName);
        // console.log('program: ' + program);
        // console.log('campus: ' + campus);
        // console.log('zip: ' + zip);
      };
    }
  };

  Drupal.behaviors.multistepFieldTracking = {
    attach: function (context, settings) {
      setTimeout(function() {
        $('div[id^="edit-step-2"] input:not([type="submit"]), div[id^="edit-step-2"] select', context).on('change', function(e) {
          var form = $(this).closest('form');
          if ($(this).closest('form').hasClass('hybrid-registration') && this.type === 'hidden') return;
          var formId = $(this).closest('form').attr('id');
          var formName =  sessionStorage.getItem('concorde_form_current');

          if ($('div[id^="edit-step-2"]').closest('.js-modal-window').length) {
            formName += ' (Modal)';
          }

          var fieldName = $(this).attr('name');
          var fieldValue = $(this).val();
          var start = fieldName.indexOf('[');
          var end = fieldName.indexOf(']');
          if (start !== -1 && end !== -1) {
            fieldName = fieldName.substring(start + 1, end);
          }
          if (fieldName === 'LocationID') { fieldName = 'campus'; }
          if (fieldName === 'campus') { fieldValue = campusCodes[fieldValue] || fieldValue; }

          if(!piiFields.includes(fieldName) && fieldValue !== '') {
            // dataLayer.push({
            //   'event': 'ce_formField',
            //   'fieldName': fieldName,
            //   'formName': formName,
            //   'fieldValue': fieldValue
            // });
            // console.log('EVENT: ce_formField multistep');
            // console.log('formName: ' + formName);
            // console.log('fieldname: ' + fieldName);
            // console.log('fieldValue: ' + fieldValue);
            if (fieldName === 'zip') {
              sessionStorage.setItem('concorde_form_zip', fieldValue);
            }
            if (fieldName === 'campus') {
              sessionStorage.setItem('concorde_form_campus', fieldValue);
            }
            if (fieldName === 'program') {
              sessionStorage.setItem('concorde_form_program', fieldValue);
            }
          }
        });
      }, 1000);
    }
  };

  var pageFormStarted = false;

  Drupal.behaviors.initializeDataLayer = {
    attach: function (context) {
      $(once('initializeDataLayerBehavior', 'form.webform-submission-form', context)).each(function() {
        var $form = $(this);
        var formId = $form.attr('id');
        var formName = getFriendlyFormName(formId);
        var multistep = false;
        var params = new URLSearchParams(window.location.search);
        if ($form.hasClass('multistep-form')) {
          multistep = true;
        }

        setTimeout(function() {
          pushFormContext($form, formName);
        }, 0);

        $form.on('change', '.concorde_webform_campus_area_program_program, .concorde_webform_campus_area_program_campus, [name$="[program]"], [name="program"], [name$="[LocationID]"], [name="LocationID"], [name="campus"], [name="event_choice"]', function() {
          pushFormContext($form, formName);
        });

        $form.on('focus', 'input, select', function(e) {
          if (!pageFormStarted) {
            if ($form.closest('.js-modal-window').length) {
              formName += ' (Modal)';
            }

            if (params.has('page') && multistep) {
              return;
            }

            dataLayer.push({
              'event': 'webform_start',
              'form_name': formName
            });

            // console.log('form start fired (data layer push disabled)');

            sessionStorage.setItem('concorde_form_current', formName);
            sessionStorage.setItem('concorde_form_zip', '');
            sessionStorage.setItem('concorde_form_campus', '');
            sessionStorage.setItem('concorde_form_program', '');

            pageFormStarted = true;
            sessionStorage.setItem('page_form_started', 'true');


          }
        });
      });
    }
  };

  Drupal.behaviors.formDataLayer = {
    attach: function (context, settings) {

      setTimeout(function() {
        $('form.webform-submission-form input, form.webform-submission-form select', context).on('change', function(e) {
          var form = $(this).closest('form');
          if ($(this).closest('form').hasClass('hybrid-registration') && this.type === 'hidden') return;
          var formId = $(this).closest('form').attr('id');
          var formName = getFriendlyFormName(formId);
          if (form.closest('.js-modal-window').length) {
            formName += ' (Modal)';
          }
          var fieldName = $(this).attr('name');
          var fieldValue = $(this).val();
          var start = fieldName.indexOf('[');
          var end = fieldName.indexOf(']');
          if (start !== -1 && end !== -1) {
            fieldName = fieldName.substring(start + 1, end);
          }
          if (fieldName === 'LocationID') { fieldName = 'campus'; }
          if (fieldName === 'campus') { fieldValue = campusCodes[fieldValue] || fieldValue; }
          var multistep = false;
          var params = new URLSearchParams(window.location.search);


          if(!piiFields.includes(fieldName) && fieldValue !== '') {
            dataLayer.push({
              'event': 'ce_formField',
              'fieldName': fieldName,
              'formName': formName,
              'fieldValue': fieldValue
            });

            // console.log('EVENT: ce_formField standard');
            // console.log('formName: ' + formName);
            // console.log('fieldname: ' + fieldName);
            // console.log('fieldValue: ' + fieldValue);

            if (fieldName === 'zip') {
              sessionStorage.setItem('concorde_form_zip', fieldValue);
            }
            if (fieldName === 'campus') {
              sessionStorage.setItem('concorde_form_campus', fieldValue);
            }
            if (fieldName === 'program') {
              sessionStorage.setItem('concorde_form_program', fieldValue);
            }
          }
        });
      }, 1000);

      $(once('initializeFormSubmitDataLayerBehavior', 'form.webform-submission-form', context)).each(function() {
        const form = $(this);
        form.on('submit', function(e) {
          // Hybrid conversions are emitted only by the successful AJAX response.
          if (form.hasClass('hybrid-registration')) return;
          if (form.data('formSubmitted')) {
            // e.preventDefault();
            // return;
            // console.log('form already submitted');
          }

          form.data('formSubmitted', true);

          let formId = form.attr('id');
          let formName = getFriendlyFormName(formId);

          if (form.closest('.js-modal-window').length) {
            formName += ' (Modal)';
          }

          let program = form.find('.concorde_webform_campus_area_program_program').val();
          let rawCampus = form.find('.concorde_webform_campus_area_program_campus').val();
          let campus = campusCodes[rawCampus] || rawCampus;
          let zip = form.find('.form-item-zip input').val();
          var multistep = false;
          var params = new URLSearchParams(window.location.search);
          if (form.hasClass('multistep-form')) {
            multistep = true;
          }

          if (!multistep) {
            dataLayer.push({
              'event': 'ce_formSubmit',
              'formName': formName,
              'program': program,
              'campus': campus,
              'zip': zip
            });
          }

          // console.log('EVENT: ce_formSubmit normal');
          // console.log('formName: ' + formName);
          // console.log('program: ' + program);
          // console.log('campus: ' + campus);
          // console.log('zip: ' + zip);

        });
      });

    }
  };

  function onDocDataLayerReady(context) {

    const $elements = $(once('initializeDlBehaviors', 'body', context));
    $elements.each(function() {

      // Primary navigation
      $('#primary-nav ul.navbar-nav a').click(function (e) {
        dataLayer.push({
          'event': 'ce_navigationClick', 'menuType': 'header', 'menuItemName': $(this).text() });
      });

      // Footer navigation
      $('#footer_links a').click(function (e) {
        dataLayer.push({
          'event': 'ce_navigationClick', 'menuType': 'footer', 'menuItemName': $(this).text() });
      });

      // Breadcrumb navigation
      $('ol.breadcrumb a').click(function (e) {
        dataLayer.push({
          'event': 'ce_navigationClick', 'menuType': 'breadcrumb', 'menuItemName': $(this).text() });
      });

      // Secondary Nav
      $('#secondary-nav a').click(function (e) {
        dataLayer.push({
          'event': 'ce_navigationClick', 'menuType': 'sticky nav', 'menuItemName': $(this).text() });
      });

      // Chat
      $('body').on('click', '.chat-now-btn', function(e) {
        dataLayer.push({
          'event': 'chat_interact', 'chat_action': 'chat open' });
        // console.log('chat open');
      });

      //Accordion
      $('.acc-item').click(function (e) {
        window.dataLayer.push({
          'event': 'ce_expandList',
          'listName': $(this).closest('[data-list-name]').data("list-name"),
          'listItem': $(this).data("list-item")
        });
      });

      // Chat close
      $('body').on('click', '#chatbot-close-button, div.jetsense-chatbot-minimize', function(e) {
        dataLayer.push({
          'event': 'chat_interact', 'chat_action': 'chat terminated' });
        // console.log('chat terminated');
      });

      // Home hero CTA
      $('.path-frontpage #hero a.btn').click(function (e) {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'hero_cta_click']);
      });


    });
  }

  Drupal.behaviors.initializeDlBehavior = {
    attach: function (context) {
      onDocDataLayerReady(context);
    }
  };

})(jQuery, Drupal);
